import Slider from "./_slider";
import app from "../_app";

const images = document.querySelector('.js-image-slider');

if(images && app.viewport.isSmallerThan('lg')) {
    const slider = new Slider(images, {
        autoplay: false,
        arrows: false,
        dots: false,
    });
}
